import shareImgBg from '../img/share-news-bg.png'
import shareImgBottom from '../img/share-news-bottom.png'
import shareImgIcon from '../img/share-news-icon.png'
import icon22 from '../img/icon22.png'
import React, { useState, useEffect } from "react";
import loadingImg from '../img/loding.gif'
import html2canvas from 'html2canvas'
function ShareLayer(props) {
    // const [isShowLayer, setIsShowLayer] = useState(false);

    const [shareImg, setShareImg] = useState()
    const [start, setStart] = useState(false)
    const [loading, setLoading] = useState(false)
    const startCreat = () => {
        setLoading(true)
        setStart(true)
        html2canvas(document.getElementById('shareImg'), {
            backgroundColor: 'transparent',
            useCORS: true,

        }).then((canvas) => {
            let url = canvas.toDataURL("image/png");
            setLoading(false)
            setShareImg(url)


        });
    }

    const handleClick = () => {
        const { sendFn } = props
        sendFn(false)
    }

    const CreatShareImg = () => {
        return (
            loading ?
                <div className='u-loading'>
                    <img src={loadingImg} />
                    <p>图片生成中...</p>
                </div> :
                <div className='u-canvaShareImg'>
                    <img src={shareImg} />
                    <a href='javascript:void(0)' className='u-close' onClick={handleClick}>
                        关闭
                    </a>
                </div>
        )
    }


    return (
        <div className='g-layer'>
            {
                !start ?
                    <div>
                        <div className="m-share-news" id='shareImg'>
                            <img src={shareImgBg} className='u-share-news-bg' />
                            <img src={shareImgBottom} className='u-share-news-bottom' />
                            <div className='m-share-news-date'>
                                <div className='u-day'>
                                    <span>12</span>
                                    <span className='u-line'>/</span>
                                    <span className='u-big'>28</span>
                                </div>
                                <div className='u-year'>
                                    <span>2022</span>
                                    星期三
                                </div>
                            </div>

                            <div className='m-share-news-box'>
                                <img src={shareImgIcon} className='u-share-icon' />
                                <div className='m-title-box'>
                                    <div className='u-news-info'>
                                        <div>
                                            <span>{props.news.event_time_str == '' ? '--:--' : props.news.event_time_str}</span>
                                            <span>{props.news.country}</span>
                                        </div>
                                    </div>

                                    <p className='u-news-title'>
                                        {props.news.title}
                                    </p>
                                </div>

                                {
                                    props.news.remarks.length > 0 ? <div className='m-news-comment'>
                                        <img src={icon22} />
                                        {props.news.remarks[0].desc}

                                    </div> : ''
                                }



                            </div>
                        </div>
                        <div className='m-share-news-button'>
                            <span className='close' onClick={handleClick}>关闭</span>
                            <span className='creat-img' onClick={startCreat}>生成图片</span>
                        </div>
                    </div>
                    :
                    <CreatShareImg />
            }

        </div>
    )
}
export default ShareLayer